import { render, staticRenderFns } from "./DettaglioBolla.vue?vue&type=template&id=0a78a43c&scoped=true&"
import script from "./DettaglioBolla.vue?vue&type=script&lang=js&"
export * from "./DettaglioBolla.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioBolla.vue?vue&type=style&index=0&id=0a78a43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78a43c",
  null
  
)

export default component.exports